import React from 'react';
import { Buttons, CancelButton, Currency, DeleteButton, ModalCard } from '~/components';

function IssueCreditNoteDialog({ onResolve, total, currency }) {
  const handleClose = () => {
    onResolve(false);
  };

  return (
    <ModalCard title="Issue Credit Note" onClose={handleClose}>
      <ModalCard.Body>
        Are you sure that you want to issue a credit note for <Currency value={total} currency={currency} />?
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={handleClose}>Cancel</CancelButton>
          <DeleteButton onClick={() => onResolve(true)}>Issue</DeleteButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default IssueCreditNoteDialog;
